import { Component, Prop, h, State, Host, Element } from '@stencil/core';
import state from './pn-mainnav-store';
import { angle_small_down, arrow_right, open_in_new } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-mainnav-link',
  styleUrl: 'pn-mainnav-link.scss',
  shadow: false,
})
export class PnMainnavLink {
  @Element() hostElement: HTMLElement;

  /** Name */
  @Prop() name: string = '';
  /** Href */
  @Prop() href: string = '';
  /** Target */
  @Prop() target: string = '';
  /** Link id */
  @Prop() linkid: string = '';

  /** Level ID that we control toggle on */
  @State() levelId: string = '';
  /** Menu item is open */
  @State() open: boolean = false;
  @State() hasChildren: boolean = false;

  componentWillLoad() {
    this.hasChildren = this.hostElement.querySelectorAll('pn-mainnav-level').length > 0;
    if (this.hasChildren && this.name) {
      const safeLevelName = this.name.toLowerCase().replace(/\W/gi, '_');
      this.levelId = `mainnav-lvl${2}-${safeLevelName}`;
    }
  }

  setOpenMenuLevel() {
    state.openLevel = state.openLevel + '' === this.levelId + '' ? '' : this.levelId;
  }

  render() {
    return (
      <Host role="listitem" name={this.name} href={this.href} linkid={this.linkid}>
        {this.hasChildren ? (
          <button onClick={this.setOpenMenuLevel.bind(this)} aria-controls={this.levelId} aria-expanded={(state.openLevel + '' === this.levelId + '') + ''} aria-haspopup="true">
            {this.name}
            <pn-icon class="first-level_icon" icon={angle_small_down} color="blue700" />
            <pn-icon class="first-level_arrow" icon={arrow_right} color="blue700" />
          </button>
        ) : (
          <a
            href={this.href}
            {...(this.target ? { target: this.target } : {})}
            {...(this.target === '_blank' ? { rel: 'nofollow noopener' } : {})}
            {...(this.linkid ? { id: this.linkid } : {})}
          >
            {this.name}
            {this.target === '_blank' ? <pn-icon icon={open_in_new} color="blue700"></pn-icon> : null}
          </a>
        )}
        <slot></slot>
      </Host>
    );
  }
}
